module.exports = __webpack_public_path__ + "static/media/5-2.1ddb5609.mp3";